import React from 'react';

interface Props {
  active: boolean;
  onClick: () => void;
  title: string;
  description?: string;
  disabled?: boolean;
}

export function RadioOption({ active, onClick, title, description, disabled }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={active}
      className={[
        'flex gap-2.5 items-start w-full text-left px-3.5 py-3 border-t border-ink-100',
        'bg-transparent btn-focus transition-colors',
        active ? 'bg-green-100' : 'hover:bg-ink-100/40',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
      ].join(' ')}
    >
      <span
        className={[
          'inline-flex items-center justify-center mt-0.5 w-[18px] h-[18px] rounded-full shrink-0',
          'border-2 transition-colors',
          active ? 'border-green-700 bg-green-700' : 'border-ink-300 bg-transparent',
        ].join(' ')}
      >
        {active && <span className="w-1.5 h-1.5 rounded-full bg-white" />}
      </span>
      <span className="flex-1 min-w-0">
        <span
          className={[
            'block font-display font-bold text-[13px] text-ink-900',
            description ? 'mb-0.5' : '',
          ].join(' ')}
        >
          {title}
        </span>
        {description && (
          <span className="block text-[11px] text-ink-500 leading-snug">{description}</span>
        )}
      </span>
    </button>
  );
}
